import './LookaheadActivity.css';
import LookaheadActivity from './LookaheadActivity';

export default LookaheadActivity;
